<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zuobGa/tc-custom/9781401689339.jpg?1703390233228" alt="This image is the cover for the book Choice to Forgive, Amish Christmas Novellas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Choice to Forgive, Amish Christmas Novellas
      </h1>
      <p class="bookDescription body article font2">
        <p>After Daniel disappeared that long-ago Christmas Eve, Lydia built a life with his brother. But now she's a widow and Daniel has reappeared, asking for forgiveness. Can she go back to her normal life with her long-lost love as her neighbor?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth Wiseman
      </h2>
      
      <p class="authorDescription body article"><P>Bestselling and award-winning author Beth Wiseman has sold over two million books. She is the recipient of the coveted Holt Medallion, is a two-time Carol Award winner, and has won the Inspirational Reader's Choice Award three times. Her books have been on various bestseller lists, including CBA, ECPA, Christianbook, and <I>Publishers Weekly</I>. Beth and her husband are empty nesters enjoying country life in south-central Texas. Visit her online at BethWiseman.com; Facebook: @AuthorBethWiseman; Twitter: @BethWiseman; Instagram: @bethwisemanauthor</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e5de7cd